import classNames from "classnames";
import React from "react";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PaginationControls = ({ onClick, direction, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "border-2 rounded-[4px] relative inline-flex items-center p-3.5 min-w-[30px] h-[30px] justify-center text-sm font-medium gap-2 hidden sm:flex",
        "bg-white text-black hover:bg-gray-100 focus:outline-none focus:ring-2 focus:text-primary",
        disabled ? "opacity-50 cursor-not-allowed" : "hover:text-primary",
        direction === 1 ? "rounded-r-md" : "rounded-l-md"
      )}
    >
      {direction !== -1 && `Next`}
      <FontAwesomeIcon
        icon={direction === -1 ? faArrowLeft : faArrowRight}
        className="w-3.5 h-3.5"
        aria-hidden="true"
      />
      {direction === -1 && `Previous`}
    </button>
  );
};

export default PaginationControls;
